import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import './Facilities.css';
import { SLIDER_AUTOPLAY_DELAY_MS } from '../constants/sliderTiming';
import useScrollAnimation from '../constants/useScrollAnimation';

const facilities = [
  {
    id: 1,
    title: 'Smart Classrooms',
    bgColor: '#0B5ED7',
    image: '/images/facilities/smart-classrooms.jpg',
    icon: '/images/facilities/icon/smart-classrooms.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 2,
    title: 'Robotics Lab',
    bgColor: '#6F42C1',
    image: '/images/facilities/robotics-lab.jpg',
    icon: '/images/facilities/icon/robotics-lab.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 3,
    title: 'Art & Craft',
    bgColor: '#FF7043',
    image: '/images/facilities/art-craft.jpg',
    icon: '/images/facilities/icon/art-craft.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 4,
    title: 'Music',
    bgColor: '#8E24AA',
    image: '/images/facilities/music.jpg',
    icon: '/images/facilities/icon/music.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 5,
    title: 'Yoga',
    bgColor: '#2E7D32',
    image: '/images/facilities/yoga.jpg',
    icon: '/images/facilities/icon/yoga.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 6,
    title: 'Taekwondo',
    bgColor: '#D32F2F',
    image: '/images/facilities/taekwondo.jpg',
    icon: '/images/facilities/icon/taekwondo.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 7,
    title: 'Karate',
    bgColor: '#EF6C00',
    image: '/images/facilities/karate.jpg',
    icon: '/images/facilities/icon/karate.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 8,
    title: 'Nature Club',
    bgColor: '#2E7D32',
    image: '/images/facilities/nature-club.jpg',
    icon: '/images/facilities/icon/nature-club.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 9,
    title: 'Literary Club',
    bgColor: '#8E2430',
    image: '/images/facilities/literary-club.jpg',
    icon: '/images/facilities/icon/literary-club.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 10,
    title: 'Photography Club',
    bgColor: '#455A64',
    image: '/images/facilities/photography-club.jpg',
    icon: '/images/facilities/icon/photography-club.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 11,
    title: 'Adventure Sports Club',
    bgColor: '#E65100',
    image: '/images/facilities/adventure-sports-club.jpg',
    icon: '/images/facilities/icon/adventure-sports-club.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 12,
    title: 'International Language Classes',
    bgColor: '#00897B',
    image: '/images/facilities/international-language-classes.jpg',
    icon: '/images/facilities/icon/international-language-classes.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 13,
    title: 'Infrastructure',
    bgColor: '#0A3D62',
    image: '/images/facilities/infrastructure.jpg',
    icon: '/images/facilities/icon/infrastructure.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 14,
    title: 'Transport',
    bgColor: '#F9A825',
    image: '/images/facilities/transport.jpg',
    icon: '/images/facilities/icon/transport.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 15,
    title: 'Infirmary',
    bgColor: '#E53935',
    image: '/images/facilities/infirmary.jpg',
    icon: '/images/facilities/icon/infirmary.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 17,
    title: 'Hostel',
    bgColor: '#6D4C41',
    image: '/images/facilities/hostel.jpg',
    icon: '/images/facilities/icon/hostel.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 18,
    title: 'Security',
    bgColor: '#263238',
    image: '/images/facilities/security.jpg',
    icon: '/images/facilities/icon/security.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 19,
    title: 'International Student Exchange',
    bgColor: '#039BE5',
    image: '/images/facilities/international-exchange.jpg',
    icon: '/images/facilities/icon/international-exchange.png',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];

export default function FacilitiesSection() {
  const [selectedFacility, setSelectedFacility] = useState(facilities[0]);
  const swiperRef = useRef(null);
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <section id="facilities" className="facilities-section">
      <div className="container-custom">
        {/* Section Header */}
        <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
          <div className="section-title-body">
            <div>
              <h3 className="section-title-hm">Facilities</h3>
            </div>
            <div>
              <a href="#" class="btn-com school-view"> Learn more</a>
            </div>
          </div>
          <p className="section-desc body-txt">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic
          </p>
        </div>

        {/* Section Body */}
        <div ref={contentRef} className="facilities-wrapper">
          {/* Main Display Image (Left side) */}
          <div id="facilities-photo-card" className={`facilities-photo-card photo-card facilities-left ${isContentVisible ? "animate-in" : ""}`}>
            <img
              id="facilities-photo-img"
              src={selectedFacility.image}
              alt={selectedFacility.title}
              className="facilities-photo-img photo-img"
            />
          </div>

          {/* Cards Carousel (Right side) */}
          <div className={`facilities-scroll-wrapper facilities-right ${isContentVisible ? "animate-in" : ""}`}>
            <Swiper
              modules={[Navigation, Autoplay]}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
              speed={1400}
              grabCursor={true}
              autoplay={{
                delay: SLIDER_AUTOPLAY_DELAY_MS || 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              slidesPerView={4}
              spaceBetween={16}
              breakpoints={{
                1200: { slidesPerView: 3, spaceBetween: 16 },
                992: { slidesPerView: 3, spaceBetween: 16 },
                768: { slidesPerView: 2, spaceBetween: 14 },
                0: { slidesPerView: 1, spaceBetween: 10 },
              }}
              onSlideChange={(swiper) => {
                const realIndex = swiper.realIndex;
                if (facilities[realIndex]) {
                  setSelectedFacility(facilities[realIndex]);
                }
              }}
              className="facilities-swiper"
            >
              {facilities.map((item) => {
                const isSelected = selectedFacility.id === item.id;
                return (
                  <SwiperSlide key={item.id}>
                    <div
                      id={`facilities-card-${item.id}`}
                      className={`facilities-card facility-card ${isSelected ? 'facilities-card-active active-card' : ''}`}
                      style={{ backgroundColor: item.bgColor }}
                      onClick={() => {
                        setSelectedFacility(item);
                        if (swiperRef.current) {
                          const index = facilities.findIndex((f) => f.id === item.id);
                          if (index !== -1) {
                            swiperRef.current.slideToLoop(index);
                          }
                        }
                      }}
                    >
                      {/* Top Icon */}
                      <div className="facilities-card-icon card-icon">
                        <img src={item.icon} alt={item.title} />
                      </div>

                      {/* Content Box */}
                      <div className="card-content">
                        <h3 className="facilities-card-title card-title">{item.title}</h3>

                        {item.description && (
                          <p className="card-text">{item.description}</p>
                        )}

                        {/* <a
                          href="#"
                          className="card-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <span>Explore</span>
                          <svg
                            className="arrow-icon"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="none"
                          >
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                          </svg>
                        </a> */}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            {/* Slider Navigation Buttons */}
            <div className="facilities-nav navigation-controls success-nav d-flex align-items-center">
              <button
                id="facilities-prev-btn"
                className="facilities-nav-btn facilities-prev success-nav-btn success-prev"
                aria-label="Previous"
                onClick={handlePrev}
              >
                <img
                  src="/images/sussess-stories/icon/arrow-left.png"
                  alt="Previous"
                  className="facilities-nav-icon success-nav-icon"
                />
              </button>
              <button
                id="facilities-next-btn"
                className="facilities-nav-btn facilities-next success-nav-btn success-next"
                aria-label="Next"
                onClick={handleNext}
              >
                <img
                  src="/images/sussess-stories/icon/arrow-right.png"
                  alt="Next"
                  className="facilities-nav-icon success-nav-icon"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}